import React from "react";
import dayjs from "dayjs";
import { Stack } from "@mui/material";

import {
  HubButton,
  HubFilterMenu,
  HubFilterTimeMenu,
  HubHookFormWrapper,
} from "../../components";
import { DEPARTMENTS } from "../../constants";

import ContactsLocationFilter from "../Companies/ContactsLocationFilter";
import { useHubSnackBar, useWorkOrdersContext } from "../../hooks";
import { useHandleMultiPageDownload } from "../../helpers";

const printedStatus = [
  {
    id: "true",
    label: "Printed",
  },
  {
    id: "false",
    label: "Not Printed",
  },
];
export const WorkOrdersBar = () => {
  const { count = 0 } = useWorkOrdersContext();
  const snackbar = useHubSnackBar();

  const date = dayjs().format("MM/DD/YYYY");
  const name = `travelers-${date}`;

  const handleDownload = useHandleMultiPageDownload({
    name,
    print: false,
    snackbar,
  });
  // const handlePrint = useHandleMultiPageDownload({
  //   name,
  //   print: true,
  //   snackbar,
  // });

  return (
    <HubHookFormWrapper onSubmit={() => {}} sx={{ width: "100%" }}>
      <Stack justifyContent="space-between" direction="row" width="100%">
        <Stack direction="row" gap="10px">
          <ContactsLocationFilter multiSelect={false} />
          <HubFilterMenu
            id="printed"
            icon="FileText"
            options={printedStatus}
            menuLabel="Filter By Print Status"
            label="Printed"
            useDefault={false}
          />
          <HubFilterMenu
            id="departments"
            icon="Archive"
            options={DEPARTMENTS}
            menuLabel="Filter By Department"
            label="Department"
            useDefault={false}
          />
          <HubFilterTimeMenu
            id="startDate"
            label="Start Date"
            icon="Calendar"
          />
          <HubFilterTimeMenu
            id="createdAt"
            label="Created Date"
            icon="Calendar"
          />
        </Stack>
        <Stack direction="row" gap="10px">
          {/* <HubButton
            size="xsmall"
            label={`Print ${count > 0 ? `${count} ` : ""}Work Order(s)`}
            variant="contained"
            color="neutral"
            icon="FileText"
            iconProps={{ size: 12 }}
            disabled={count <= 0}
            onClick={handlePrint}
          /> */}
          <HubButton
            size="xsmall"
            label={`Download ${count > 0 ? `${count} ` : ""}Work Order(s)`}
            variant="contained"
            color="neutral"
            icon="Share2"
            iconProps={{ size: 12 }}
            disabled={count <= 0}
            onClick={handleDownload}
          />
        </Stack>
      </Stack>
    </HubHookFormWrapper>
  );
};

export default WorkOrdersBar;
